import { WorkflowsService } from '@/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  BaseEdge,
  EdgeLabelRenderer,
  MarkerType,
  getBezierPath,
  useReactFlow,
  type EdgeProps,
} from '@xyflow/react';
import { toast } from 'sonner';

export type CustomEdgeProps = EdgeProps & {
  workflowId: string;
};
export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd = MarkerType.ArrowClosed,
  workflowId,
}: CustomEdgeProps) {
  const { setEdges } = useReactFlow();
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const queryClient = useQueryClient();
  const removeEdgeMutation = useMutation({
    mutationFn: async (edgeId: string) => {
      if (workflowId) {
        $deletingEdge.set(true);
        const res = await WorkflowsService.removeWorkflowEdge(
          workflowId,
          edgeId,
        );
        return res;
      }
    },
    onSuccess: async data => {
      await queryClient.invalidateQueries({
        queryKey: ['getWorkflow', workflowId],
      });
      $deletingEdge.set(false);
    },
    onError: error => {
      console.error(error);
      $deletingEdge.set(false);
      // show a toast message
      toast('An error occurred :: Unable to add node.', {
        description: error.message,
        duration: 5000,
      });
    },
  });

  //   const onEdgeClick = async () => {
  //     await removeEdgeMutation.mutateAsync(id);
  //     setEdges(edges => edges.filter(edge => edge.id !== id));
  //   };

  const removeEdge = async () => {
    await removeEdgeMutation.mutateAsync(id);
    // setEdges(edges => edges.filter(edge => edge.id !== id));
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            // everything inside EdgeLabelRenderer has no pointer events by default
            // if you have an interactive element, set pointer-events: all
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
        >
          {/* <Button
            variant="outline"
            size="icon"
            className="h-6 w-6"
            onClick={async () => {
              await removeEdge();
            }}
            disabled={removeEdgeMutation.isPending}
          >
            <Cross1Icon className="h-2 w-2" />
          </Button> */}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
